document.addEventListener('DOMContentLoaded', function () {
  const tabsContainers = document.querySelectorAll('.product-upsells-tabs');
  if (!tabsContainers.length) return;

  // Carousel helpers — one shared nav per tabsContainer, driving the active tab's slider
  const getActiveSlider = (tabsContainer) => {
    const activeContent = tabsContainer.querySelector('.product-upsells-tabs__content.active');
    return activeContent ? activeContent.querySelector('.product-upsells-tabs__slider') : null;
  };

  const updateNavState = (tabsContainer) => {
    const nav = tabsContainer.querySelector('.product-upsells-tabs__nav');
    const prev = tabsContainer.querySelector('.product-upsells-tabs__arrow--prev');
    const next = tabsContainer.querySelector('.product-upsells-tabs__arrow--next');
    const slider = getActiveSlider(tabsContainer);
    if (!nav || !prev || !next || !slider) return;

    const items = slider.querySelectorAll('.upsells-tabs__item');
    if (items.length <= 1) {
      nav.hidden = true;
      return;
    }
    nav.hidden = false;

    const maxScroll = slider.scrollWidth - slider.clientWidth;
    prev.disabled = slider.scrollLeft <= 1;
    next.disabled = slider.scrollLeft >= maxScroll - 1;
  };

  const initTabsContainer = (tabsContainer) => {
    tabsContainer.querySelectorAll('.product-upsells-tabs__slider').forEach(slider => {
      if (slider.dataset.carouselInit === 'true') return;
      slider.dataset.carouselInit = 'true';
      slider.addEventListener('scroll', () => updateNavState(tabsContainer), { passive: true });
    });
    window.addEventListener('resize', () => updateNavState(tabsContainer));
    updateNavState(tabsContainer);
  };

  tabsContainers.forEach(tabsContainer => {
    initTabsContainer(tabsContainer);

    // Event Delegation for everything inside the container
    tabsContainer.addEventListener('click', (e) => {

      // Carousel arrows (shared nav → active tab's slider)
      const arrow = e.target.closest('.product-upsells-tabs__arrow');
      if (arrow) {
        e.preventDefault();
        const slider = getActiveSlider(tabsContainer);
        if (!slider) return;
        const firstItem = slider.querySelector('.upsells-tabs__item');
        const step = firstItem ? firstItem.getBoundingClientRect().width + 8 : slider.clientWidth;
        const direction = arrow.classList.contains('product-upsells-tabs__arrow--prev') ? -1 : 1;
        slider.scrollBy({ left: step * direction, behavior: 'smooth' });
        return;
      }

      // 1. Tab Switching Logic
      const header = e.target.closest('.product-upsells-tabs__header');
      if (header) {
        e.preventDefault();
        const targetTabId = header.dataset.tab;

        // Find parent container again to be safe, though tabsContainer is in scope
        const parentContainer = header.closest('.product-upsells-tabs');

        // Update Headers
        const allHeaders = parentContainer.querySelectorAll('.product-upsells-tabs__header');
        allHeaders.forEach(h => h.classList.remove('active'));
        header.classList.add('active');

        // Update Content
        const allContents = parentContainer.querySelectorAll('.product-upsells-tabs__content');
        allContents.forEach(content => {
          if (content.id === targetTabId) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

        // Recompute nav state now that the new slider has real dimensions
        requestAnimationFrame(() => updateNavState(parentContainer));
        return;
      }

      // 2. Add to Cart Logic
      const addButton = e.target.closest('.upsell-product-card__add-btn');
      if (addButton) {
        e.preventDefault();

        const variantId = addButton.dataset.variantId;
        if (!variantId) {
          console.error('Variant ID missing');
          return;
        }

        if (addButton.dataset.hasMultipleVariants === 'true') {
          if (!window.openVariantSelectionPopup) {
              const drawer = document.getElementById('Cart-Drawer');
              if (!drawer) return;
              const jsUrl = drawer.getAttribute('data-popup-js-url');
              const cssUrl = drawer.getAttribute('data-popup-css-url');

              const spinner = addButton.querySelector('.loading-overlay__spinner');
              const btnText = addButton.querySelector('.upsell-product-card__add-btn-text');

              if (spinner) spinner.classList.remove('hidden');
              if (btnText) btnText.style.opacity = '0';

              if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
                  const link = document.createElement('link');
                  link.rel = 'stylesheet';
                  link.href = cssUrl;
                  document.head.appendChild(link);
              }

              if (jsUrl && !document.querySelector(`script[src="${jsUrl}"]`)) {
                  const script = document.createElement('script');
                  script.src = jsUrl;
                  script.onload = () => {
                      if (spinner) spinner.classList.add('hidden');
                      if (btnText) btnText.style.opacity = '1';
                      window.openVariantSelectionPopup(addButton);
                  };
                  document.head.appendChild(script);
                  return;
              }
          } else {
              window.openVariantSelectionPopup(addButton);
          }
          return;
        }

        const spinner = addButton.querySelector('.loading-overlay__spinner');
        const btnText = addButton.querySelector('.upsell-product-card__add-btn-text');

        // Show Spinner
        if (spinner) spinner.classList.remove('hidden');
        if (btnText) btnText.style.opacity = '0';

        const formData = {
          'items': [{
            'id': variantId,
            'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data.status) {
              console.error('Error adding to cart:', data.description);
              // Revert button state on error
              if (spinner) spinner.classList.add('hidden');
              if (btnText) btnText.style.opacity = '1';
              return;
            }
            // Fire cart:item-added so Meta Pixel tracks AddToCart
            dispatchCustomEvent('cart:item-added', {
              product: data.hasOwnProperty('items') ? data.items[0] : data
            });

            // Trigger Cart Drawer Refresh
            dispatchCustomEvent('cart:refresh');
            dispatchCustomEvent('cart-drawer:open');

            const cartDrawer = document.getElementById('Cart-Drawer');
            if (cartDrawer) {
                document.body.classList.add('open-cc');
                document.body.classList.add('open-cart');
                cartDrawer.classList.add('active');
                if (cartDrawer.querySelector('.product-recommendations--full')) {
                    cartDrawer.querySelector('.product-recommendations--full').classList.add('active');
                }
            } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                window.CartDrawer.open();
            } else if (window.theme && typeof window.theme.cart === 'object' && typeof window.theme.cart.open === 'function') {
                window.theme.cart.open();
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            // Hide Spinner
            if (spinner) spinner.classList.add('hidden');
            if (btnText) btnText.style.opacity = '1';
          });
      }
    });
  });
});
